// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__bq-8V","secondIcon":"Icon_secondIcon__B0BZz","loader":"Icon_loader__T89g4","rotation":"Icon_rotation__sOutN"};